import { render, staticRenderFns } from "./CarlGaming.vue?vue&type=template&id=1a003dc2"
import script from "./CarlGaming.vue?vue&type=script&lang=js"
export * from "./CarlGaming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports